import { render, staticRenderFns } from "./tord_pay_list.vue?vue&type=template&id=f8ca7484&scoped=true&"
import script from "./tord_pay_list.vue?vue&type=script&lang=js&"
export * from "./tord_pay_list.vue?vue&type=script&lang=js&"
import style0 from "./tord_pay_list.vue?vue&type=style&index=0&id=f8ca7484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ca7484",
  null
  
)

export default component.exports